<template>
  <div class="el-tabs__inner" v-if="obj && storeObj.conditions">
    <b-row class="row-bg">
      <b-col :cols="('requirement' in storeObj.conditions) ? 12 : 12">
        <b-row>
          <b-col cols="4"><h5>Visibility Conditions</h5></b-col>
          <b-col cols="8">
            Evaluate <b>visibility</b>  conditions with <select v-model="storeObj.conditions.visibility_operand">
              <option>AND</option>
              <option>OR</option>
            </select> logic
          </b-col>
        </b-row>
        <hr>
        <template  v-if="storeObj.conditions.visibility.length">
          <b-row v-for="(condition, index) in storeObj.conditions.visibility" :key="`v_${index}`" style="margin-bottom: 10px">
            <b-col cols="7">
              <select class="form-control" v-model="condition.actor" @change="changeActor(condition)">
                <option disabled="" selected="">Select...</option>
                  <optgroup :label="section.title" v-for="section in conditioners" :key="`v_s_${section.id}_${index}`">
                      <option :value="item.tagname" v-for="item in section.fields" :key="`v_${item.id}_${index}`">{{ item.label }}</option>
                  </optgroup>
              </select>
            </b-col>
            <b-col cols="1">
              <select class="form-control" :disabled="!condition.actor" v-model="condition.cond">
                <option disabled="" selected="">Select...</option>
                <option :value="'=='" v-if="condition.comparable">Is</option>
                <option :value="'!='" v-if="condition.comparable">Not</option>
                <option :value="'**'">Filled</option>
                <option :value="'!!'">Empty</option>
                <option :value="'$$'">Same</option>
                <option :value="'@@'">Diff</option>
              </select>
            </b-col>
            <b-col cols="3">
              <template v-if="isComparable(condition)">
                  <select class="form-control" v-model="condition.value">
                    <option disabled="" selected="">Select...</option>
                      <optgroup :label="section.title" v-for="section in conditioners" :key="`v_s_${section.id}_${index}`">
                          <option :value="item.tagname" v-for="item in section.fields" :key="`v_${item.id}_${index}`">{{ item.label }}</option>
                      </optgroup>
                  </select>
              </template>
              <template v-else>
                <template v-if="!isSelectorDisabled(condition)">
                  <select class="form-control" :disabled="isSelectorDisabled(condition)" v-model="condition.value">
                    <option disabled="" selected="">Select...</option>
                    <option v-if="condition.actor && condition.cond" :value="opt.optionValue" v-for="(opt, optIndex) in findConditionByTag(condition.actor)" :key="`v_${opt.id}_${optIndex}_${condition.actor}`">{{ opt.optionLabel }}</option>
                  </select>
                </template>
              </template>
            </b-col>
            <b-col cols="1">
              <button class="btn btn-outline-danger" @click.prevent="deleteConditional('visibility', index)"><i class="la la-trash"></i></button>
            </b-col>
          </b-row>
        </template>
        <b-row v-else>
          <b-col cols="12"><em>No Conditions have been set</em></b-col>
        </b-row>
        <b-row class="row-bg">
          <b-col>
              <br>
              <button class="btn btn-sm btn-warning" style="color: black" @click.prevent="addCondition('visibility')">Add Visibility Condition</button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <hr>
      </b-col>

      <b-col cols="12" v-if="'requirement' in storeObj.conditions">
        <b-row>
          <b-col cols="4"><h5>Requirement Conditions</h5></b-col>
          <b-col cols="8">
            Evaluate <b>requirement</b> conditions with <select v-model="storeObj.conditions.requirement_operand">
              <option>AND</option>
              <option>OR</option>
            </select> logic
          </b-col>
        </b-row>
        <hr>
        <template v-if="storeObj.conditions.requirement.length">
          <b-row v-for="(condition, index) in storeObj.conditions.requirement" :key="`r_${index}`" style="margin-bottom: 10px">
            <b-col cols="7">
              <select class="form-control" v-model="condition.actor" @change="changeActor(condition)">
                <option disabled="" selected="">Select...</option>
                  <optgroup :label="section.title" v-for="section in conditioners" :key="`r_s_${section.id}_${index}`">
                      <option :value="item.tagname" v-for="item in section.fields" :key="`r_${item.id}_${index}`">{{ item.label }}</option>
                  </optgroup>
              </select>
            </b-col>
            <b-col cols="1">
              <select class="form-control"  :disabled="!condition.actor" v-model="condition.cond">
                <option disabled="" selected="">Select...</option>
                <option :value="'=='" v-if="condition.comparable">Is</option>
                <option :value="'!='" v-if="condition.comparable">Not</option>
                <option :value="'**'">Filled</option>
                <option :value="'!!'">Empty</option>
                <option :value="'$$'">Same</option>
                <option :value="'@@'">Diff</option>
              </select>
            </b-col>
            <b-col cols="3">
              <template v-if="isComparable(condition)">
                  <select class="form-control" v-model="condition.value">
                    <option disabled="" selected="">Select...</option>
                      <optgroup :label="section.title" v-for="section in conditioners" :key="`r_s_${section.id}_${index}`">
                          <option :value="item.tagname" v-for="item in section.fields" :key="`r_${item.id}_${index}`">{{ item.label }}</option>
                      </optgroup>
                  </select>
              </template>
              <template v-else>
                <template v-if="!isSelectorDisabled(condition)">
                  <select class="form-control" :disabled="isSelectorDisabled(condition)" v-model="condition.value">
                      <option disabled="" selected="">Select...</option>
                      <option v-if="condition.actor && condition.cond" :value="opt.optionValue" v-for="(opt, optIndex) in findConditionByTag(condition.actor)" :key="`r_${opt.id}_${optIndex}_${condition.actor}`">{{ opt.optionLabel }}</option>
                    </select>
                  </template>
              </template>
            </b-col>
            <b-col cols="1">
              <button class="btn btn-outline-danger" @click.prevent="deleteConditional('requirement', index)"><i class="la la-trash"></i></button>
            </b-col>
          </b-row>
        </template>
        <b-row v-else>
          <b-col cols="12"><em>No Conditions have been set</em></b-col>
        </b-row>
        <b-row class="row-bg">
          <b-col>
            <br>
            <button class="btn btn-sm btn-warning" style="color: black" @click.prevent="addCondition('requirement')">Add Requirement Condition</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {
  FormBuilder
} from '@/components/bs/formbuilder';
import draggable from 'vuedraggable';

export default {
  name: 'Conditioning',
  store: ['activeField', 'conditioners', 'editingSection', 'activeSection', 'editingButton'],
  components: {
    draggable
  },

  computed: {
    obj () {
      var formElementFlag = this.editingSection ? 'activeSection' : 'activeField'
      if(this.editingButton) {
        return 'formButton';
      }
      return formElementFlag;
    },

    storeObj () {
      return this.$store[this.obj];
    }
  },

  methods: {

    changeActor (condition) {
      var rawCondition = null
      this.conditioners.forEach(conditioner => {
          rawCondition = rawCondition ?? conditioner.fields.find(rawCondition => {
            return rawCondition.tagname === condition.actor
          })
      })


      if(rawCondition) {
        condition.actorId = rawCondition.id
        condition.comparable = rawCondition.comparable
      }
    },

    isSelectorDisabled(condition) {
      return !condition.actor || !condition.cond || ['**', '!!'].indexOf(condition.cond) >= 0
    },

    isComparable(condition) {
      return ['$$', '@@'].indexOf(condition.cond) >= 0
    },

    deleteConditional(type, index) {
      if(confirm('Are you sure?')){
        this.$store[this.obj].conditions[type].splice(index, 1);
      }
    },

    findConditionByTag(tagname) {

      if(!tagname) {
        return []
      }

      var candidate = null

      this.conditioners.forEach(conditioner => {
          candidate = candidate ?? conditioner.fields.find(rawCondition => {
            return rawCondition.tagname === tagname
          })
      })


      if(!candidate) {
        return []
      }

      return candidate.options
    },

    addCondition (type) {
      this.$store[this.obj].conditions[type].push({
        actor: null,
        cond: null,
        value: null,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button__sidebar {
    width: 100%;
    margin-bottom: 5px;

    .is-disabled & {
        opacity: 0.4;
    }
}

// Display this ghost in <main> only
 .sortable__ghost {
    position: relative;
    width: 33.33%;
    border-bottom: 2px solid #3A8EE6;
    margin-top: 2px;
    margin-bottom: 2px;

    [type="button"] {
        display: none;
    }

    &:before {
        content: "Drag it here";
        background-color: #ECF5FF;
        color: #3A8EE6;
        position: absolute;
        left: 50%;
        font-size: 10px;
        border-radius: 10px;
        line-height: 15px;
        padding: 0 10px;
        top: -6px;
        transform: translateX(-50%);
    }
}
</style>
